import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { USER_GET_INFO } from "../Utils/Strings/Service_Endpoint";


export function getUserInfo() {
  return {
    [CALL_API]: {
      endpoint: USER_GET_INFO,
      authenticated: true,
      types: [
        actionType.SERVICE_USERINFO_REQUEST,
        actionType.SERVICE_USERINFO_SUCCESS,
        actionType.SERVICE_USERINFO_ERROR
      ]
    }
  };
}



// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Home.js